module.exports = __webpack_public_path__ + "img/bg-careers-section-perks-and-benefits.6ab68414.png";